import type { LogContext, Logger } from './logger';

export function createCompositeLogger(...loggers: Logger[]): Logger {
  return {
    debug: (msg, ctx) =>
      loggers.forEach((l) => {
        l.debug(msg, ctx);
      }),
    info: (msg, ctx) =>
      loggers.forEach((l) => {
        l.info(msg, ctx);
      }),
    warn: (msg, ctx, err) =>
      loggers.forEach((l) => {
        l.warn(msg, ctx, err);
      }),
    error: (msg, ctx, err) =>
      loggers.forEach((l) => {
        l.error(msg, ctx, err);
      }),
    withContext: (ctx: LogContext) => createCompositeLogger(...loggers.map((l) => l.withContext(ctx))),
  };
}
